import { useEffect } from 'react';
import { create } from 'zustand';
import { type StateStorage, createJSONStorage, persist } from 'zustand/middleware';

import type { IntakeVariant } from '~/stores/intake-variant-store';

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

type IntakeProgressState = {
  /** Furthest step reached per version, so finished steps stay one click away. */
  furthest: Partial<Record<IntakeVariant, number>>;
  markReached: (variant: IntakeVariant, stepIdx: number) => void;
  resetProgress: () => void;
};

export const useIntakeProgressStore = create<IntakeProgressState>()(
  persist(
    (set) => ({
      furthest: {},
      markReached: (variant, stepIdx) =>
        set((state) =>
          (state.furthest[variant] ?? -1) >= stepIdx
            ? state
            : { furthest: { ...state.furthest, [variant]: stepIdx } }
        ),
      resetProgress: () => set({ furthest: {} }),
    }),
    {
      name: 'conduit-intake-progress',
      storage: createJSONStorage(() =>
        typeof window === 'undefined' ? noopStorage : sessionStorage
      ),
      skipHydration: true,
    }
  )
);

export function useIntakeProgress() {
  useEffect(() => {
    void useIntakeProgressStore.persist.rehydrate();
  }, []);
  return useIntakeProgressStore();
}
